import { render } from "./partnerLevelDetails.vue?vue&type=template&id=d5410376"
import script from "./partnerLevelDetails.vue?vue&type=script&lang=js"
export * from "./partnerLevelDetails.vue?vue&type=script&lang=js"

import "./partnerLevelDetails.vue?vue&type=style&index=0&id=d5410376&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__